import React from 'react';

function Add({ stroke = '#545659', width = 16, height = 16, style }) {
  return (
    <svg style={style} width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 6V12M12 12V18M12 12H18M12 12H6" stroke={stroke} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  );
}

export default Add;
